import { Component, inject, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SkeletonModule } from 'primeng/skeleton';

export interface VehicleCardData {
  image?: string | null;
  make?: VehicleCardTranslatableName | null;
  model?: VehicleCardTranslatableName | null;
  color?: string | null;
  productionYear?: number | null;
  licensePlate?: VehicleCardLicensePlate | null;
}

export interface VehicleCardTranslatableName {
  englishName?: string | null;
  arabicName?: string | null;
}

export interface VehicleCardLicensePlate {
  plateLetters?: string | null;
  plateDigits?: string | null;
}

@Component({
  selector: 'app-vehicle-card',
  standalone: true,
  imports: [SkeletonModule],
  templateUrl: './vehicle-card.component.html',
  styleUrl: './vehicle-card.component.scss'
})
export class VehicleCardComponent {
  private readonly translate = inject(TranslateService);

  @Input() vehicle?: VehicleCardData | null;
  @Input() selected = false;
  @Input() loading = false;

  get imageAlt(): string {
    return this.vehicleName || 'vehicle';
  }

  get plateText(): string {
    return [this.vehicle?.licensePlate?.plateLetters, this.vehicle?.licensePlate?.plateDigits]
      .filter((value): value is string => !!value)
      .join(' - ');
  }

  get vehicleName(): string {
    const nameKey = this.translate.currentLang === 'ar' ? 'arabicName' : 'englishName';
    const fallbackNameKey = nameKey === 'arabicName' ? 'englishName' : 'arabicName';

    return [
      this.vehicle?.make?.[nameKey] || this.vehicle?.make?.[fallbackNameKey],
      this.vehicle?.model?.[nameKey] || this.vehicle?.model?.[fallbackNameKey]
    ]
      .filter((value): value is string => !!value)
      .join(' ');
  }

  get hasVehicleSpecs(): boolean {
    return !!this.vehicle?.color || (!!this.vehicle?.productionYear && this.vehicle.productionYear !== 0);
  }
}
